import React from 'react';
import { Redirect } from 'react-router-dom';
import useRoutes from '../../routes/useRoutes';

const RedirectToMenu = () => {
  const routes = useRoutes();
  return <Redirect to={routes.menuRoute()} />;
};

export default RedirectToMenu;
